import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { titleEventEmitter } from './title-event-emitter';
/**
 * Component to set the page title.
 * When this component is used in a page, it emits an event to update the title in the header.
 */
var PageTitle = function (_a) {
    var children = _a.children;
    useEffect(function () {
        titleEventEmitter.emit(children);
        return function () {
            titleEventEmitter.emit(null);
        };
    }, [children]);
    return null;
};
/**
 * Portal component to render the page title in the layout header.
 * Listens for title updates emitted by the PageTitle component and displays a default title if none is set.
 */
var PageTitlePortal = function (_a) {
    var _b = _a.defaultTitle, defaultTitle = _b === void 0 ? 'Título Padrão' : _b;
    var _c = useState(defaultTitle), title = _c[0], setTitle = _c[1];
    useEffect(function () {
        var handleTitleChange = function (newTitle) {
            setTitle(newTitle || defaultTitle);
        };
        titleEventEmitter.on(handleTitleChange);
        return function () {
            titleEventEmitter.off(handleTitleChange);
        };
    }, [defaultTitle]);
    return (_jsx(Typography, { variant: "h6", alignSelf: "center", children: title }));
};
var PageTitleComponent = Object.assign(PageTitle, {
    Portal: PageTitlePortal,
});
export default PageTitleComponent;
